module.exports = __webpack_public_path__ + "static/media/s1.68fbf439.jpg";